import React, { memo, useState, useEffect } from "react";
import { apiGetQuizUrl } from "Root/api/apiQuiz";
import x from "Images/quiz/x.svg";
import logo from "Images/quiz/logo_square.svg";
import starter from "Images/quiz/starter.png";
import starterMobile from "Images/quiz/starterMobile.png";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { useTracking } from "react-tracking";
import styles from "./styles.module.css";
import QuizTrack from "../../data/trackingEnums";
import posthog from "posthog-js";

const QuizStart = () => {
  const [url, setUrl] = useState("");
  const { trackEvent } = useTracking();
  const { search } = useLocation();

  const trackViewQuiz = () => {
    trackEvent({
      funComponent: "quiz",
      event: `${QuizTrack.view_quiz}`,
    });
  };

  useEffect(async () => {
    const redirect = window.location.pathname.replace("/quiz-start/", "");
    if (redirect) {
      setUrl(`/${redirect}`);
    } else {
      const data = await apiGetQuizUrl();
      if (data) {
        setUrl(data);
      }
    }
    trackViewQuiz();
    posthog.capture("quiz_start", { url: window.location.href });
  }, []);

  const history = useHistory();

  const routeChange = () => {
    const path = `/quiz/`;
    history.push(path);
    history.go(0);
  };

  const quitUrl = () => {
    const urlParams = new URLSearchParams(search);
    if (urlParams.has("prev") && urlParams.get("prev") === "pdp") {
      return "/shop";
    }
    return "/";
  };

  return (
    <>
      <div className={styles.starterScreen} id="starterScreen">
        <img alt="starterImage" className={styles.starterImage} src={starter} />
        <img alt="starterImageMobile" className={styles.starterImageMobile} src={starterMobile} />
        <div className={styles.starterBanner}>
          <a href="/">
            <img alt="logo" src={logo} />
          </a>
          <a href={quitUrl()} className={styles.controlX}>
            <img alt="controlX" src={x} />
          </a>
        </div>

        <div className={styles.starterTextContain}>
          <h3 className={styles.starterHeader}>Getting to know you.</h3>
          <p>
            This short, 5-minute quiz helps us understand your physiology, dietary needs, and goals so that our experts
            can design a nutrition system that works specifically for you.
          </p>

          <div className={styles.mobileBtnContainer}>
            {url === "" ? (
              <button type="submit" className={styles.starterBtn} onClick={routeChange}>
                Get Started
              </button>
            ) : (
              <Link to={url} className={styles.starterBtn}>
                Get Started
              </Link>
            )}
            <div>
              <p className={styles.already}>Already gave us your email?</p>
              <a className={styles.starterSecondaryBtn} href="/existing-login/">
                Resume Here
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(QuizStart);
